import React, { useEffect, useState } from 'react' 
import {OrderContext} from '../../Global/OrderContext'; 
import {db} from '../../Config/Config';
import './order.css';

export const Orders = () => { 
     
 const [bookings, setBookings] = useState([]);

  useEffect(() =>  {  

    let prevOrders = []; 

    db.collection('Bookings').onSnapshot(snapshot => { 
     let changes = snapshot.docChanges(); 
     changes.forEach((change) => { 
       if(change.type === "added") {  
          prevOrders.push({  
               BuyerName: change.doc.data().BuyerName,
               BuyerEmail: change.doc.data().BuyerEmail,
               BuyerCell: change.doc.data().BuyerCell,
               BuyerAddress: change.doc.data().BuyerAddress,
               BuyerPayment: change.doc.data().BuyerPayment,
               BuyerQuantity: change.doc.data().BuyerQuantity
          });
       } 
       setBookings(prevOrders);
    })
  }) 
 });

    return (

    <div class="table-container"> 

      <h2> Customer Bookings </h2> 

      <ul class="responsive-table"> 
        <li class="table-header">
          <div class="col col-1">Customer Name</div> 
          <div class="col col-2">Telephone Number</div>
          <div class="col col-3">Address</div>
          <div class="col col-4">Total Price</div> 
          <div class="col col-5">Khaftan Quantity</div> 
        </li>
         
          {bookings.length === 0 && <div> No Orders Currently available </div> }
          {bookings.map((items) => { 
            return ( 
          <li class="table-row">
            <div class="col col-1" data-label="Job Id">{items.BuyerName}</div>
            <div class="col col-2" data-label="Customer Name">{items.BuyerCell}</div>
            <div class="col col-3" data-label="Amount">{items.BuyerAddress}</div>
            <div class="col col-4" data-label="Payment Status">GH₵ {items.BuyerPayment}</div>
            <div class="col col-5" data-label="Payment Status">{items.BuyerQuantity}</div>
          </li>
         )})}
     
      </ul>
    </div>
    );
}
